<script setup>
import { ref } from 'vue';
import ImagePreview from '../ImagePreview.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});
const showGallery = ref(false);

const { filteredCurrentChatAttachments } = useMessageContext();

</script>

<template>
  <ImagePreview
    :key="attachment.dataUrl"
    :src="attachment.dataUrl"
    :width="attachment.width"
    :height="attachment.height"
    :max-width="72"
    :max-height="72"
    fixed-frame
    @open="showGallery = true"
  />
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @close="() => (showGallery = false)"
  />
</template>
